export default {
  getAdimplencia(state) {
    return state.adimplencia
  }
}
